import {
  createBillableItem as publicCreateBillableItem,
  getBillableItem as publicGetBillableItem,
  updateBillableItem as publicUpdateBillableItem,
  deleteBillableItem as publicDeleteBillableItem,
  queryBillableItems as publicQueryBillableItems,
  typedQueryBillableItems as publicTypedQueryBillableItems,
  bulkCreateBillableItems as publicBulkCreateBillableItems,
  bulkUpdateBillableItems as publicBulkUpdateBillableItems,
  bulkDeleteBillableItems as publicBulkDeleteBillableItems,
  bulkUpdateBillableItemTags as publicBulkUpdateBillableItemTags,
  bulkUpdateBillableItemTagsByFilter as publicBulkUpdateBillableItemTagsByFilter,
  searchBillableItems as publicSearchBillableItems,
} from './billable-items-v1-billable-item-billable-items.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  BillableItemQuery,
  BillableItemsQueryBuilder,
  typedQueryBillableItems as universalTypedQueryBillableItems,
} from './billable-items-v1-billable-item-billable-items.universal.js';
import { onBillableItemCreated as publicOnBillableItemCreated } from './billable-items-v1-billable-item-billable-items.public.js';
import { onBillableItemDeleted as publicOnBillableItemDeleted } from './billable-items-v1-billable-item-billable-items.public.js';
import { onBillableItemUpdated as publicOnBillableItemUpdated } from './billable-items-v1-billable-item-billable-items.public.js';

function customQueryBillableItems(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryBillableItems(httpClient)(),
    typedQueryFunction: (query: BillableItemQuery) =>
      publicTypedQueryBillableItems(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): BillableItemsQueryBuilder;
  function overloadedQuery(
    query: BillableItemQuery
  ): ReturnType<typeof universalTypedQueryBillableItems>;
  function overloadedQuery(query?: BillableItemQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createBillableItem: MaybeContext<
  BuildRESTFunction<typeof publicCreateBillableItem> &
    typeof publicCreateBillableItem
> = /*#__PURE__*/ createRESTModule(publicCreateBillableItem);
export const getBillableItem: MaybeContext<
  BuildRESTFunction<typeof publicGetBillableItem> & typeof publicGetBillableItem
> = /*#__PURE__*/ createRESTModule(publicGetBillableItem);
export const updateBillableItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateBillableItem> &
    typeof publicUpdateBillableItem
> = /*#__PURE__*/ createRESTModule(publicUpdateBillableItem);
export const deleteBillableItem: MaybeContext<
  BuildRESTFunction<typeof publicDeleteBillableItem> &
    typeof publicDeleteBillableItem
> = /*#__PURE__*/ createRESTModule(publicDeleteBillableItem);
export const bulkCreateBillableItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateBillableItems> &
    typeof publicBulkCreateBillableItems
> = /*#__PURE__*/ createRESTModule(publicBulkCreateBillableItems);
export const bulkUpdateBillableItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateBillableItems> &
    typeof publicBulkUpdateBillableItems
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateBillableItems);
export const bulkDeleteBillableItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteBillableItems> &
    typeof publicBulkDeleteBillableItems
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteBillableItems);
export const bulkUpdateBillableItemTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateBillableItemTags> &
    typeof publicBulkUpdateBillableItemTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateBillableItemTags);
export const bulkUpdateBillableItemTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateBillableItemTagsByFilter> &
    typeof publicBulkUpdateBillableItemTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateBillableItemTagsByFilter);
export const searchBillableItems: MaybeContext<
  BuildRESTFunction<typeof publicSearchBillableItems> &
    typeof publicSearchBillableItems
> = /*#__PURE__*/ createRESTModule(publicSearchBillableItems);
export const queryBillableItems: MaybeContext<
  BuildRESTFunction<typeof customQueryBillableItems> &
    typeof customQueryBillableItems
> = /*#__PURE__*/ createRESTModule(customQueryBillableItems);
/**
 * Triggered when a billable item is created.
 */
export const onBillableItemCreated: BuildEventDefinition<
  typeof publicOnBillableItemCreated
> &
  typeof publicOnBillableItemCreated = createEventModule(
  publicOnBillableItemCreated
);
/**
 * Triggered when a billable item is deleted.
 */
export const onBillableItemDeleted: BuildEventDefinition<
  typeof publicOnBillableItemDeleted
> &
  typeof publicOnBillableItemDeleted = createEventModule(
  publicOnBillableItemDeleted
);
/**
 * Triggered when a billable item is updated.
 */
export const onBillableItemUpdated: BuildEventDefinition<
  typeof publicOnBillableItemUpdated
> &
  typeof publicOnBillableItemUpdated = createEventModule(
  publicOnBillableItemUpdated
);

export {
  WebhookIdentityType,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  Mode,
} from './billable-items-v1-billable-item-billable-items.universal.js';
export {
  BillableItem,
  ExtendedFields,
  Tags,
  TagList,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateBillableItemRequest,
  CreateBillableItemResponse,
  GetBillableItemRequest,
  GetBillableItemResponse,
  UpdateBillableItemRequest,
  UpdateBillableItemResponse,
  DeleteBillableItemRequest,
  DeleteBillableItemResponse,
  QueryBillableItemsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryBillableItemsResponse,
  CursorPagingMetadata,
  Cursors,
  InternalQueryBillableItemsRequest,
  InternalCursorQuery,
  InternalCursorQueryPagingMethodOneOf,
  InternalCursorPaging,
  InternalQueryBillableItemsResponse,
  BulkCreateBillableItemsRequest,
  BulkCreateBillableItemsResponse,
  ItemMetadata,
  ApplicationError,
  BulkBillableItemResult,
  BulkActionMetadata,
  BulkUpdateBillableItemsRequest,
  MaskedBillableItem,
  BulkUpdateBillableItemsResponse,
  BulkUpdateBillableItemsResponseBulkBillableItemResult,
  BulkDeleteBillableItemsRequest,
  BulkDeleteBillableItemsResponse,
  BulkDeleteBillableItemsResponseBulkBillableItemResult,
  BulkUpdateBillableItemTagsRequest,
  BulkUpdateBillableItemTagsResponse,
  BulkUpdateBillableItemTagsResult,
  BulkUpdateBillableItemTagsByFilterRequest,
  BulkUpdateBillableItemTagsByFilterResponse,
  SearchBillableItemsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  SearchDetails,
  SearchBillableItemsResponse,
  PagingMetadataV2,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  BillableItemCreatedEnvelope,
  BillableItemDeletedEnvelope,
  BillableItemUpdatedEnvelope,
  UpdateBillableItem,
  BillableItemsQueryResult,
  BillableItemsQueryBuilder,
  BillableItemQuerySpec,
  BulkCreateBillableItemsOptions,
  BulkUpdateBillableItemsOptions,
  BulkUpdateBillableItemTagsOptions,
  BulkUpdateBillableItemTagsByFilterOptions,
  BillableItemSearchSpec,
} from './billable-items-v1-billable-item-billable-items.universal.js';
export { utils } from './billable-items-v1-billable-item-billable-items.universal.js';
export {
  WebhookIdentityTypeWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  CreateBillableItemApplicationErrors,
  BulkUpdateBillableItemTagsApplicationErrors,
  BulkUpdateBillableItemTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  BillableItemQuery,
  CommonSearchWithEntityContext,
  BillableItemSearch,
} from './billable-items-v1-billable-item-billable-items.universal.js';
